import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api, setSubmitterToken } from "../../lib/api";
import PublicHeader from "../../components/PublicHeader";
import SiteFooter from "../../components/SiteFooter";

export default function VerifyMagic() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) { setError("This sign-in link is missing its token."); return; }
    (async () => {
      try {
        const { data } = await api.get(`/auth/magic/verify?token=${encodeURIComponent(token)}`);
        setSubmitterToken(data.session_token);
        navigate(data.redirect || "/my-submissions", { replace: true });
      } catch (err) {
        setError(err.response?.data?.detail || "This link didn't work — request a new one.");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen bg-[#f5f3ed] flex flex-col" data-testid="verify-page">
      <PublicHeader pub={null} />
      <div className="flex-1 flex items-center justify-center px-6 py-16 text-center">
        {error ? (
          <div data-testid="verify-error">
            <h1 className="text-3xl font-bold mb-4">Link problem</h1>
            <p className="text-sm text-black mb-6">{error}</p>
            <a href="/login" className="btw-link" data-testid="verify-retry">Request a new link</a>
          </div>
        ) : (
          <p className="text-sm text-[#5c5852]" data-testid="verify-loading">Signing you in…</p>
        )}
      </div>
      <SiteFooter />
    </div>
  );
}
